/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import Rating from '@material-ui/lab/Rating';
import uniqueId from 'lodash/uniqueId';

import Avatar from '../../../../components/helper/avatar';
import KrService from '../../../services/kr.service';
import EmojiContainer from '../../../../components/emojis/emojis';
import { InitializeGoalCommentEditor } from '../../../../utils/editors';
import GoalServices from '../../../../services/goal.services';
import { OkrPopUp } from '../../../types/okrpopup.types';
import { WbMarkdownHtml } from '../../../../utils/common';
import CommentAccessComp from '../../../okr_comment/CommentAceessComp';

type OkrReviewState = {
    reviewComments: any,
    reviewCommentId: string,
    reviewUserInvited: boolean,
    reviewCommentsCount: any,
    displayFireworks: boolean,
    rating: any
}

const ReviewCommentsBlock = (props) => {
    const id = useRef(uniqueId());
    return (
    <div style={{ display: 'flex' }}>
        <div className="okr_review_left" role="list" aria-label="User Ratings">
            {props.reviewComments.map((review: any) => (
                <div
                    className="okr_review_block"
                    id={`review_${review.goalCommentId}`}
                    style={props.commentsCount === 1 && review.comment ? { marginTop: 90 } : {}}
                    key={id.current}
                    role="listitem"
                >
                    <div className="okr_reviewer_user_pic">
                        <Avatar src={review.picture} imageClass="okr-review-profile" useSpriteSheet={false} />
                    </div>
                    <div className="okr_review_body">
                        <div className="okr_review_rating">
                            <Rating
                                name="simple-controlled"
                                value={review.rating}
                                readOnly
                                style={{ color: '#52bad5' }}
                                size="small"
                            />
                        </div>
                        {review.comment
                            ? (
                                <div
                                    className="okr_review_comment"
                                    dangerouslySetInnerHTML={WbMarkdownHtml(review.comment)}
                                />
                            )
                            : ''}
                        <div className="okr_review_full_name">
                            {review.fullName}
                        </div>
                        <div />
                    </div>
                </div>
            ))}
        </div>
        {
            props.displayFireworks
                ? <div className="okr_review_right"><div className="okr_review_fireworks" /></div>
                : <></>
        }
    </div>
    );
}

class OKRReviewSection extends React.Component<OkrPopUp, OkrReviewState> {
    constructor (props: any) {
        super(props);
        this.state = {
            reviewComments: [],
            reviewCommentId: '',
            reviewUserInvited: false,
            reviewCommentsCount: null,
            displayFireworks: false,
            rating: 0
        }
        this.krService = new KrService();
        this.goalService = new GoalServices();
        this.editorId = `goal_comment_edit_editor_${this.props.goalId}`;
        this.onPostReview = this.onPostReview.bind(this);
    }

    componentDidMount () {
        const params = { goalId: this.props.goalId, json: 1 };
        const contentId = document.getElementById('content');
        showLoaderWidget(contentId);
        this.krService.getGoalReviewComments(params)
            .then((response) => {
                this.setState({
                    reviewComments: response.data[0].goals.closed_goal_comments,
                    reviewCommentId: response.data[0].goals.user_comment_id,
                    reviewUserInvited: response.data[0].goals.user_invited,
                    reviewCommentsCount: response.data[0].goals.closed_goal_comments_count,
                    displayFireworks: response.data[0].goals.achieved_goal == '1'
                }, () => {
                    removeLoader();
                    if (this.state.reviewUserInvited) {
                        let editor = CKEDITOR.instances[this.editorId];
                        if (this.props.goalId !== null) {
                            if (editor) {
                                editor.destroy(true);
                            } else {
                                InitializeGoalCommentEditor(this.editorId);
                            }
                            editor = CKEDITOR.instances[this.editorId];
                            if (!editor) {
                                InitializeGoalCommentEditor(this.editorId);
                            }
                        }
                    }
                })
            })
            .catch((err: any) => {
                console.log('err', err);
                removeLoader();
            });
    }

    onPostReview (e) {
        e.preventDefault();
        e.stopPropagation();
        const contentId = document.getElementById('content');
        showLoaderWidget(contentId);
        let cvalue = CKEDITOR.instances[this.editorId].getData();
        if (cvalue != 'undefined' && cvalue.trim()) {
            cvalue = cvalue.trim();
        } else {
            alert('Please enter the comment.');
            return;
        }
        this.goalService.saveClosedGoal({
            goal_id: this.props.goalId,
            status: 0,
            rating: this.state.rating,
            closed_comment: cvalue,
            id: this.state.reviewCommentId
        }).then((response) => {
            if (response.data.error) {
                removeLoader();
                alert(response.data.error);
            } else if (response.status == 200) {
                const params = { goalId: this.props.goalId, json: 1 };
                this.krService.getGoalReviewComments(params)
                    .then((comments) => {
                        this.setState({
                            reviewComments: comments.data[0].goals.closed_goal_comments,
                            reviewCommentId: comments.data[0].goals.user_comment_id,
                            reviewUserInvited: comments.data[0].goals.user_invited,
                            reviewCommentsCount: comments.data[0].goals.closed_goal_comments_count,
                        })
                    });
                removeLoader();
            }
        });
    }

    editorId: string;

    goalService: GoalServices;

    krService: KrService;

    render () {
        const { t } = this.props;
        return (
            <div className="okr_review_section">
                {this.state.reviewUserInvited
                    && (
                        <div className="cmt-comments-wrapper">
                            <fieldset className="cmt-comments-label cmt-comments-reviews">
                                <legend className="goalRatingLabel">{t('How did this OKR go?')}</legend>
                                <div className="okr_review_rating">
                                    <Rating
                                        name="simple-controlled"
                                        value={this.state.rating}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                rating: newValue
                                            })
                                        }}
                                        style={{ color: '#52bad5' }}
                                        size="small"
                                    />
                                </div>
                                <CommentAccessComp />
                            </fieldset>
                            {this.props.goalId
                                && (
                                    <div className="editor_main_wrap">
                                        <div className="comment-input-box">
                                            <textarea
                                                className="goal_comment_edit_editor"
                                                id={this.editorId}
                                                placeholder={t("Add a comment")}
                                            />
                                            <input type="hidden" className="hiddenUserId" value="" />
                                            <div className="smiley-container">
                                                <EmojiContainer editorId={this.editorId} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            <div className="close-goal-review-btn-div">
                                <input
                                    type="button"
                                    value={t("Post review")}
                                    className="gbl-btn gbl-btn-slim close-goal-review-btn"
                                    onClick={this.onPostReview}
                                />
                            </div>
                        </div>
                    )}
                <ReviewCommentsBlock
                    commentsCount={this.state.reviewCommentsCount}
                    reviewComments={this.state.reviewComments}
                    displayFireworks={this.state.displayFireworks}
                />
            </div>
        )
    }
}

export default React.memo(withTranslation()(OKRReviewSection));
